module.exports = __webpack_public_path__ + "media/images/logo/Oneticket_tour__white-91fca417fbc31207a82b814d1bd6da6d.svg";